import { http, HttpResponse } from 'msw';

const BASE = import.meta.env?.VITE_API_BASE_URL ?? 'http://localhost:8000';

const DEMO_LEDGER_ENTRIES = [
  {
    id: 1,
    wallet_id: 1,
    entry_type: 'TRADE_PNL',
    asset: 'USDT',
    amount: '890.40',
    balance_after: '10890.40',
    reference: 'order:101',
    description: 'Realized PnL from BTC/USDT long',
    created_at: new Date(Date.now() - 2 * 3600 * 1000).toISOString(),
  },
  {
    id: 2,
    wallet_id: 1,
    entry_type: 'FEE',
    asset: 'USDT',
    amount: '-3.56',
    balance_after: '10886.84',
    reference: 'order:101',
    description: 'Trading fee for BTC/USDT',
    created_at: new Date(Date.now() - 2 * 3600 * 1000).toISOString(),
  },
  {
    id: 3,
    wallet_id: 1,
    entry_type: 'TRADE_PNL',
    asset: 'USDT',
    amount: '358.10',
    balance_after: '11244.94',
    reference: 'order:98',
    description: 'Realized PnL from ETH/USDT long',
    created_at: new Date(Date.now() - 8 * 3600 * 1000).toISOString(),
  },
  {
    id: 4,
    wallet_id: 1,
    entry_type: 'FEE',
    asset: 'USDT',
    amount: '-1.43',
    balance_after: '11243.51',
    reference: 'order:98',
    description: 'Trading fee for ETH/USDT',
    created_at: new Date(Date.now() - 8 * 3600 * 1000).toISOString(),
  },
  {
    id: 5,
    wallet_id: 1,
    entry_type: 'TRADE_PNL',
    asset: 'USDT',
    amount: '-142.30',
    balance_after: '11101.21',
    reference: 'order:95',
    description: 'Realized PnL from SOL/USDT long',
    created_at: new Date(Date.now() - 24 * 3600 * 1000).toISOString(),
  },
  {
    id: 6,
    wallet_id: 1,
    entry_type: 'PAPER_TOP_UP',
    asset: 'USDT',
    amount: '5000.00',
    balance_after: '10000.00',
    reference: 'admin:42',
    description: 'Paper wallet initial funding',
    created_at: '2026-01-15T10:00:00Z',
  },
  {
    id: 7,
    wallet_id: 1,
    entry_type: 'PAPER_TOP_UP',
    asset: 'BTC',
    amount: '0.50000000',
    balance_after: '0.50000000',
    reference: 'admin:42',
    description: 'Paper wallet BTC allocation',
    created_at: '2026-01-15T10:00:00Z',
  },
  {
    id: 8,
    wallet_id: 1,
    entry_type: 'TRADE_PNL',
    asset: 'USDT',
    amount: '210.75',
    balance_after: '11311.96',
    reference: 'order:90',
    description: 'Realized PnL from BTC/USDT short',
    created_at: new Date(Date.now() - 48 * 3600 * 1000).toISOString(),
  },
];

export const demoLedgerHandlers = [
  // ── List ledger entries ───────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/ledger`, ({ request }) => {
    const url = new URL(request.url);
    const limit = parseInt(url.searchParams.get('limit') ?? '50', 10);
    const offset = parseInt(url.searchParams.get('offset') ?? '0', 10);
    const walletId = url.searchParams.get('wallet_id');

    let items = DEMO_LEDGER_ENTRIES;
    if (walletId) {
      items = items.filter((e) => e.wallet_id === Number(walletId));
    }

    const paged = items.slice(offset, offset + limit);
    return HttpResponse.json({
      items: paged,
      total: items.length,
      limit,
      offset,
    });
  }),

  // ── Ledger consistency check ──────────────────────────────────────────────
  http.get(`${BASE}/api/v1/ledger/consistency/:walletId`, () => {
    return HttpResponse.json({
      consistent: true,
      checked_at: new Date().toISOString(),
    });
  }),
];
